<div class="message-dialog">
  <div class="content">
    <h3>Message au vendeur </h3>
    <form #messageForm="ngForm" class="message-form">

      <mat-form-field>
        <mat-label >Message</mat-label>
        <textarea matInput required type="text"  name ="body" placeholder=""  [(ngModel)] = "data.body" ></textarea>
      </mat-form-field>

      @if (data.senderId==='') {
        <mat-form-field>
          <mat-label >Nom</mat-label>
          <input matInput type="text" required name ="name" placeholder=""  [(ngModel)] = "data.senderName" >
        </mat-form-field>
      }

      @if (data.senderId==='') {
        <mat-form-field>
          <mat-label >Email</mat-label>
          <input matInput type="email" required  name ="email" placeholder=""  [(ngModel)] = "data.senderEmail" >
        </mat-form-field>
      }

      @if (data.senderId==='') {
        <mat-form-field>
          <mat-label >Code pays</mat-label>
          <input matInput type="number" required name ="phoneCode" placeholder=""  [(ngModel)] = "data.senderPhoneNumber.code" >
        </mat-form-field>
      }

      @if (data.senderId==='') {
        <mat-form-field>
          <mat-label >Numero</mat-label>
          <input matInput type="number" required name ="phoeNumber" placeholder=""  [(ngModel)] = "data.senderPhoneNumber.number" >
        </mat-form-field>
      }

    </form>

    <div class="action-buttons">
      <button class="simple-button-buy" mat-button [mat-dialog-close]="">Annuler</button>
      <button class="cta-button-buy" [disabled] = !messageForm.valid mat-button [mat-dialog-close]="data" >
        <mat-icon>send</mat-icon> Envoyer
      </button>
    </div>
  </div>
</div>
